import AdsReservation from "./AdsReservation";
import ReservationResponse from "./ReservationResponse";

export const routes = [
   {
        path: "/reservation/ads/:adsId/:userId",
        component: AdsReservation ,
        exact: true,
        public: true
    },{
        path: "/reservation/response",
        component: ReservationResponse,
        exact: true,
        public: true
    }
];